export default __webpack_public_path__ + "static/media/sort.cac48655.svg";